import _ from 'lodash';
import ElementLocale from 'element-ui/lib/locale';
/**
 * 获取当前语言的文案
 * @param lang
 * @returns
 */
export async function getMessage(lang) {
    let results: any[] = [];
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/cn.json'),
            import('CommonMessages/analytics-search/cn.json'),
            import('CommonMessages/analytics-search-next/cn.json'),
            import('CommonMessages/analytics-image-search-next/cn.json'),
            import('CommonMessages/analytics-snap-business/cn.json'),
            import('CommonMessages/common-errorcode/cn.json'),
            import('CommonMessages/common-country/cn.json'),
            import('CommonMessages/common-product/cn.json'),
            import('CommonMessages/common-patent/cn.json'),
            import('element-ui/lib/locale/lang/zh-CN'),
            import('@patsnap-biz/email-alert/locales/cn.js'),
            import('@patsnap-biz/save-to-workspace-v2/locales/cn.js'),
            import('@patsnap-biz/corp-tree/locales/cn.js')
        ]);
    } else if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/tw.json'),
            import('CommonMessages/analytics-search/tw.json'),
            import('CommonMessages/analytics-search-next/tw.json'),
            import('CommonMessages/analytics-image-search-next/tw.json'),
            import('CommonMessages/analytics-snap-business/tw.json'),
            import('CommonMessages/common-errorcode/tw.json'),
            import('CommonMessages/common-country/tw.json'),
            import('CommonMessages/common-product/tw.json'),
            import('CommonMessages/common-patent/tw.json'),
            import('element-ui/lib/locale/lang/zh-TW'),
            import('@patsnap-biz/email-alert/locales/tw.js'),
            import('@patsnap-biz/save-to-workspace-v2/locales/tw.js'),
            import('@patsnap-biz/corp-tree/locales/tw.js')
        ]);
    } else if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/en.json'),
            import('CommonMessages/analytics-search/en.json'),
            import('CommonMessages/analytics-search-next/en.json'),
            import('CommonMessages/analytics-image-search-next/en.json'),
            import('CommonMessages/analytics-snap-business/en.json'),
            import('CommonMessages/common-errorcode/en.json'),
            import('CommonMessages/common-country/en.json'),
            import('CommonMessages/common-product/en.json'),
            import('CommonMessages/common-patent/en.json'),
            import('element-ui/lib/locale/lang/en'),
            import('@patsnap-biz/email-alert/locales/en.js'),
            import('@patsnap-biz/save-to-workspace-v2/locales/en.js'),
            import('@patsnap-biz/corp-tree/locales/en.js')
        ]);
    } else if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/jp.json'),
            import('CommonMessages/analytics-search/jp.json'),
            import('CommonMessages/analytics-search-next/jp.json'),
            import('CommonMessages/analytics-image-search-next/jp.json'),
            import('CommonMessages/analytics-snap-business/jp.json'),
            import('CommonMessages/common-errorcode/jp.json'),
            import('CommonMessages/common-country/jp.json'),
            import('CommonMessages/common-product/jp.json'),
            import('CommonMessages/common-patent/jp.json'),
            import('element-ui/lib/locale/lang/ja'),
            import('@patsnap-biz/email-alert/locales/jp.js'),
            import('@patsnap-biz/save-to-workspace-v2/locales/jp.js'),
            import('@patsnap-biz/corp-tree/locales/jp.js')
        ]);
    }
    const data = results.reduce((obj, { default: data }) => _.merge(obj, data), {});
    ElementLocale.use(data);
    return { [lang]: data };
}
